/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
import * as tslib_1 from "tslib";
import { Position } from "../../common/position";
/** `Position` with `"auto"` values, used by `Popover` and `Tooltip`. */
export var PopoverPosition = tslib_1.__assign({}, Position, { AUTO: "auto", AUTO_END: "auto-end", AUTO_START: "auto-start" });
//# sourceMappingURL=popoverSharedProps.js.map